import { MonitoringSearchCTO } from "./searchCto"

export const resolveThingName = (thingId: number, context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.monitoring.resolveThingName(
      thingId,
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}

export const resolveParameterName = (parameterId: number, context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.monitoring.resolveParameterName(
      parameterId,
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}

export const resolveParameterNames = (
  parameterIds: number[],
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.monitoring.resolveParameterNames(
      parameterIds,
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}

export const resolvePoolName = (poolId: number, context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.monitoring.resolvePoolName(
      poolId,
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}

export const searchMonitoringMessages = (searchCTO: any, context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.monitoring.searchMonitoringMessages(
      searchCTO,
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}

export const getMonitoringSeverities = (context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.monitoring.getMonitoringSeverities(
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const resolveMonitoringSeverity = (severity: string, context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.monitoring.resolveMonitoringSeverity(
      severity,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const getMonitoringOperations = (context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.monitoring.getMonitoringOperations(
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const resolveMonitoringOperation = (
  operation: string,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.monitoring.resolveMonitoringOperation(
      operation,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const loadUsage = (search: any, context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.monitoring.loadUsage(
      search,
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}

export const getMonitoringObjectTypes = (context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.monitoring.getMonitoringObjectTypes(
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}

export const resolveMonitoringObjectType = (
  objectType: string,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.monitoring.resolveMonitoringObjectType(
      objectType,
      (data: unknown) => resolve(data),
      (err: Error) => reject(err),
      context ? context : null
    )
  })
}

export const getSearchCTO = () => <MonitoringSearchCTO>(<unknown>{
    return: <MonitoringSearchCTO>(
      window.parent.primingcloud.monitoring.getSearchCTO()
    ),
  })
